import { TableItemColor } from './TableItemColor';

export interface ITableDataSetColor {
    dataSetid: string;
    fields: TableItemColor[];
}

export class TableDataSetColor implements ITableDataSetColor {
    public dataSetid: string;
    public fields: TableItemColor[];

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: ITableDataSetColor);
    constructor(obj?: any) {
        this.dataSetid = obj && obj.dataSetid || '';
        this.fields = [];
        if (obj && obj.fields != null) {
            obj.fields.forEach((field: any) => {
                this.fields.push(new TableItemColor(field));
            });
        }
    }
}

